const mapping = {
    "TP": "台北市",
    "NP": "新北市",
    "JL" : "基隆市",
    "TY" : "桃園市",
    "YL" : "宜蘭縣",
    "HS" : "新竹市",
    "HX" : "新竹縣",
    "ML" : "苗栗縣",
    "TC" : "臺中市",
    "NT" : "南投縣",
    "ZH" : "彰化縣",
    "YU" : "雲林縣",
    "CX" : "嘉義縣",
    "CS" : "嘉義市",
    "TN" : "臺南市",
    "KH" : "高雄市",
    "PD" : "屏東縣",
    "HW" : "花蓮縣",
    "TD" : "臺東縣",
    "KM" : "金門縣",
    "PH" : "澎湖縣",
    "LN" : "連江縣",
    "OT" : "其他地區",
} ;

export default mapping ;